// extracted by mini-css-extract-plugin
export default {"header":"UserHeader_header__pQE2O"};